import { NavLink } from "react-router";
import  { type RefUser,roles } from "../../types/Users";
import { formatDate } from "../../tools/utils";
import ProfilDisplay from "../Common/ProfilDisplay";
import type { Fond } from "../../types/Fond";
import { useAuth } from "../../contexts/auth/useAuth";
import { useTrads } from "../../contexts/trads/useTrads";
import parse from 'html-react-parser';

import { FondStatutManager } from "../Common/FondStatutManager";
import UserGenerated from "../Common/UserGenerated";
import TransactionFondList from "../Transactions/TransactionFondList";

function FondsItem({fond}:{fond:Fond}) {
    const {translate}=useTrads();

    const {hasRole} = useAuth();
    
    return (


            <div className="row">
                <div className="col-12">
                    <h2>{fond.name}</h2>
                    <UserGenerated component={fond}></UserGenerated>
                </div>
                
                <div className="col-6">
                    <dl className="dl-inline">
                        <dt>{translate('fond_date_debut')}</dt>
                        <dd>{formatDate(fond.date_debut)}</dd>
                        <dt>{translate('fond_date_fin')}</dt>
                        <dd>{formatDate(fond.date_fin)}</dd>
                    </dl>
                </div>
                <div className="col-3">
                    <dl className="dl-inline">
                        <dt>{translate('fond_solde')}</dt>
                        <dd>{fond.solde}€</dd>
                        <dt>{translate('fond_reel')}</dt>
                        <dd>{fond.real}€</dd>
                        <dt>{translate('fond_attente')}</dt>
                        <dd>{fond.pending}€</dd>
                    </dl>

                </div>
                <div className="col-3">
                    
                    <p  className="card-title">{translate('fond_prise_en_charge')}</p>
                    <ul className="list-group">
                        {fond.type_frais?.map(e=>(
                            <li key={e.type_frais_id} className="list-group-item ">
                                {e.name} {e.restriction && e.restriction>0?`${e.restriction.toString()}%`:null}
                            </li>
                        ))}
                    </ul>

                </div>


                {hasRole(roles.Manager)?
                <div className="row col-12">
                    <p className="h5">{translate('fond_utilisateurs')}</p>
                    <div className="card-group">
                        <div className="card">
                            <div className="card-header">
                                {translate('fond_operators')}
                                <NavLink className="float-end" to={`/fond/${fond.id.toString()}/operators`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-person-fill-gear"></i>
                                </NavLink>
                            </div>
                            {fond.operateurs?
                            <ul className="list-group list-group-flush">
                            {fond.operateurs.map((e:RefUser)=>(
                            <li className="list-group-item" key={e.id}>
                                {(e.id) ? <ProfilDisplay inscription={e} /> : 'N/A'}
                            </li>
                            ))}
                            </ul>
                            :null}
                        </div>
                        <div className="card">
                            <div className="card-header">
                                {translate('fond_beneficiaires')}
                                <NavLink className="float-end" to={`/fond/${fond.id.toString()}/beneficiaires`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-person-fill-gear"></i>
                                </NavLink>
                            </div>
                            {fond.beneficiaires?
                            <ul className="list-group list-group-flush">
                            {fond.beneficiaires.map((e:RefUser)=>(
                                <li className="list-group-item" key={e.id}>
                                    {(e.id) ? <ProfilDisplay inscription={e} /> :'N/A'}
                                </li>
                            ))}
                            </ul>
                            :null}
                        </div>
                
                    </div>
                </div>
                :null}
               

                <div className="col-12">
                    <div className="card">
                        {fond.transactions?
                        <div className="card-body">
                            <p className="h5 card-title">{translate('fond_transactions')}</p>
                            <TransactionFondList transactions={fond.transactions} />

                        </div>
                        :null}
                        {hasRole(roles.Manager)? 
                        <div className="card-footer">
                            <NavLink to={`/fond/${fond.id.toString()}/transaction`}>
                                <span className="visually-hidden">{translate('btn_add')}</span>
                                <i className="bi bi-plus-square"></i>
                            </NavLink>
                        </div>
                        :null}
                    </div>
                </div>
               

                <hr />


                {fond.publique?

                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                                <p>{translate('fond_publique')}
                                
                                </p>
                                


                               
                        </div>
                        <div className="col-6">
                            {fond.titre} {fond.perso?<i className="bi bi-person"></i>:null}
                        </div>
                        
                        <div className="col-6">
                            
                            {hasRole(roles.Administrators)?
                            <FondStatutManager fond={{"id":fond.id,"statut":fond.statut}}></FondStatutManager>
                            :<dl><dt>{translate('Statut')}</dt><dd>{translate('fond_statut_'+fond.statut)}</dd></dl>}
                            {fond.statut=="01_published"?
                            <div>
                            
                            <a href={`/fond/${(fond.slug)??fond.id.toString()}`} target="_blank">{translate('page_dons')} [ {`https://okok.be/fond/${(fond.slug)??fond.id.toString()}`} ]</a>


                                <span>
                                    <i className={`bi bi-robot ${fond.noindex?"text-danger":"text-success"}`}></i>
                                    
                                </span>
                                {fond.password?
                                <p><i className="bi bi-lock text-danger"></i> {fond.password}</p>
                                :null}

                            </div>
                            :
                            <a href={`/fond/${fond.id.toString()}?`} target="_blank">{translate('page_dons')}</a>}
                        </div>
                        
                        <div className="col-6">
                            {fond.vignette?<img src={fond.vignette.filename} alt=""/>:null}
                            
                        </div>
                        
                        <div className="col-6">
                            {translate('fond_objectif')} <span>{fond.objectif}&nbsp;€</span>
                        </div>

                        {fond.chapeau?
                        <div className="col-12">
                            {parse(fond.chapeau)}
                        </div>
                        :""}

                         {fond.descriptif?
                        <div className="col-12">
                            {parse(fond.descriptif)}
                        </div>
                        :""}
                    </div>
                </div>


                

                :null}


            </div>

    );
}
export default FondsItem;